import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

import { ScrollContainer as BaseScrollContainer, Wrap as BaseWrap } from './styled.base';

export * from './styled.base';

export const ScrollContainer = styled(BaseScrollContainer)`
  padding-top: ${primitive.$spacing11};
`;

export const Wrap = styled(BaseWrap)`
  ${Styles.desktop`
    margin-bottom: ${primitive.$spacing9};
  `}
`;
